import { normalizeResultClass } from "../Leaderboard/bullseyeResultGrouping";
import { formatCalendarDate, isDateOnlyValue } from "../../utils/date";

export const compare = (a, b) => String(a).localeCompare(String(b), undefined, { numeric: true, sensitivity: "base" });
export const relayKey = label => String(label || "").trim().replace(/^relay\s*#?\s*(\d+[a-z]?)$/i, "$1").toLowerCase();
export const relayTitle = label => !label ? "Relay not assigned" : /^relay\b/i.test(label) ? label : `Relay ${label}`;
const targetLabel = label => String(label || "").trim().replace(/^(?:firing point|point|target|lane)\s*#?\s*(\d+[a-z]?)$/i, "$1");
const divisionLabel = value => ({ open: "Open", metallic: "Metallic" })[String(value || "").toLowerCase()] || value || "Not provided";

// Shared by the screen and PDF so scoring entries never multiply physical positions.
export function relayRows(competitors = []) {
  return competitors.flatMap((person, personIndex) => {
    const positions = new Map();
    person.assignments.forEach(assignment => {
      const target = targetLabel(assignment.firingPointLabel);
      const positionKey = JSON.stringify([relayKey(assignment.relayLabel), target.toLowerCase()]);
      if (!positions.has(positionKey)) positions.set(positionKey, { target, relayLabel: assignment.relayLabel,
        name: person.rosterName || person.displayName, searchName: `${person.displayName} ${person.rosterName || ""}`,
        personIndex, key: `${personIndex}:${positionKey}`, profiles: [] });
      positions.get(positionKey).profiles.push(assignment);
    });
    return [...positions.values()].map(row => ({ ...row, hasPositionExceptions: positions.size > 1,
      groupTitle: [...new Set(row.profiles.map(profile => profile.groupTitle).filter(Boolean))].join(", ") }));
  });
}

export function profileValues(profiles, field) {
  const values = new Map();
  profiles.forEach(profile => {
    const label = field === "classification" ? (profile.classification ? normalizeResultClass(profile.classification) : "Not provided")
      : profile.twentyTwoOnly ? ".22 Only" : divisionLabel(profile.division);
    const detail = field === "division" && profile.twentyTwoOnly && profile.division ? `${divisionLabel(profile.division)} sights` : "";
    const key = JSON.stringify([label, detail]);
    if (!values.has(key)) values.set(key, { label, detail, groups: [] });
    if (profile.groupTitle) values.get(key).groups.push(profile.groupTitle);
  });
  return [...values.values()].map(value => ({ ...value, groups: values.size > 1 ? [...new Set(value.groups)].join(", ") : "" }));
}

export function relaySections(rows, relays = []) {
  return [...new Set(rows.map(row => relayKey(row.relayLabel)))].sort((a, b) => !a ? 1 : !b ? -1 : compare(a, b)).map(key => {
    const assignments = rows.filter(row => relayKey(row.relayLabel) === key).sort((a, b) =>
      !a.target && b.target ? 1 : a.target && !b.target ? -1
        : compare(a.target, b.target) || compare(a.name, b.name) || compare(a.groupTitle, b.groupTitle));
    const plan = relays.find(item => relayKey(item.label) === key);
    return { key, assignments, plan, label: relayTitle(plan?.label || assignments[0].relayLabel) };
  });
}

export function relayDateLabel(match) {
  const start = match.startDate || match.matchDate;
  return [start, match.endDate && match.endDate !== start ? match.endDate : null].filter(Boolean)
    .map(date => formatCalendarDate(date, { month: "short", day: "numeric", year: "numeric", ...(match.timeZone && !isDateOnlyValue(date) ? { timeZone: match.timeZone } : {}) })).join(" – ");
}
